/**
 * UltraAdminProductsPage — Platform Ürün Yönetimi
 * Ultra Admin, kendi ürünlerini (summitflow-platform tenant) yönetebilir.
 * ProductsSection bileşenini ultra_admin token + özel basePath ile çalıştırır.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layers } from 'lucide-react';
import AdminSidebar from '../components/AdminSidebar';
import UltraAdminTopbar from '../components/UltraAdminTopbar';
import PageIntro from '../components/PageIntro';
import { getPageIntro } from '../lib/pageIntros';
import ProductsSection from './supplier/ProductsSection';
import { useLanguage } from '../contexts/LanguageContext';

const BASE_PATH = '/ultra-admin/platform-products';

export default function UltraAdminProductsPage() {
  const { language } = useLanguage();
  const tr = language === 'tr';
  const navigate = useNavigate();

  // Auth guard — Ultra Admin token yoksa login'e yönlendir
  useEffect(() => {
    const token = localStorage.getItem('cop31_ultra_token');
    if (!token) {
      navigate('/giris?tab=ultra');
    }
  }, [navigate]);

  return (
    <div className="flex h-screen bg-gray-50">
      <AdminSidebar />
      <div className="flex-1 overflow-auto">
        <UltraAdminTopbar
          title={tr ? 'Modüler Standlar' : 'Modular Stands'}
          subtitle={tr ? 'COP 31 modüler stand kataloğu (Tier 1-4, m² bazlı)' : 'COP 31 modular stand catalog (Tier 1-4, by m²)'}
          icon={Layers}
        />
        {/* Content */}
        <div className="p-6">
          <PageIntro {...getPageIntro('platform-products', language)} />
          <ProductsSection
            tr={tr}
            overrideBasePath={BASE_PATH}
            showLinkedPackage={true}
          />
        </div>
      </div>
    </div>
  );
}
